module.exports = __webpack_public_path__ + "static/assets/11364a1ac194bc96bc1609f3785408cb.png";